const pkg = require('../../../package.json');
const Utils = require('../../utils/Utils');
const logger = require('src/utils/logger/logger');

const YouboraTracker = window.youbora.Adapter.extend({
  isAudio() {
    if (this.currentStreamContentType === null) {
        return false;
    }

    let isAudioStream = false;
    switch (this.currentStreamContentType) {
        case 'content_is_audio':
            isAudioStream = true;
            break;
        default:
            break;
    }

    return isAudioStream;
  },
  setCurrentStreamContentType(streamContentType) {
    this.currentStreamContentType = streamContentType;
  },
  getTrackerName() {
    return 'YouboraTracker';
  },

  getVersion() {
    return '6.4.0-clarovideo-js';
  },

  getPlayhead() {
    return this.currentTime;
  },

  getDuration() {
    return this.duration;
  },

  getBitrate() {
    return this.bitrate;
  },

  getRendition() {
    return this.rendition;
  },

  getTitle() {
    return this.title;
  },

  getTitle2() {
    return this.title2;
  },

  getIsLive() {
    return this.isLive;
  },

  getResource() {
    return this.src;
  },

  getPlayerVersion() {
    return this.version;
  },

  getPlayerName() {
    return 'AAF Player';
  },

  setPlayhead(currentTime) {
    // console.log("YouboraEvent setPlayhead", currentTime);

    const youboraParams = {};
    if (
      window.youboraParams &&
      Array.isArray(window.youboraParams) &&
      window.youboraParams.length > 0
    ) {
      window.youboraParams.forEach((param, index) => {
        youboraParams[`extraparam.${index + 1}`] = param.value || '';
      });

      if (
        window.youboraTrackingPlugin &&
        window.youboraTrackingPlugin.setOptions &&
        typeof window.youboraTrackingPlugin.setOptions === 'function'
      ) {
        window.youboraTrackingPlugin.setOptions(youboraParams);
      }

      this.currentTime = currentTime;

      /* TODO: Revisar para que dispositivo esta implementada esta regla :/ */

      // if (this.fireStart && typeof this.fireStart === 'function') {
      //     if (currentTime < 0.5) {
      //         this.fireStart();
      //     }
      // }

      if (currentTime > 0.5) {
        if (this.fireJoin && typeof this.fireJoin === 'function') this.fireJoin();
      }
    }
  },

  setup(e, extravalues, streamContentType = null, contentStreamType = null) {
    // console.log("YouboraEvent setup");
    let isActiveYouboraToggle = Utils.default.getStatusYouboraToggle(contentStreamType);;
    let timeActiveYoubora = isActiveYouboraToggle ? 2500 : 0;

    if (this.monitorPlayhead && typeof this.monitorPlayhead === 'function'){
     this.monitorPlayhead(isActiveYouboraToggle, isActiveYouboraToggle, timeActiveYoubora);
    }

    if(!e) return;

    const metadata = e.response || '';
    const { entry } = e;

    try {
      if (entry) {
        window.youboraParams[9].value = entry.preview && entry.preview !== '0' ? '1' : '0';
      }

      if (metadata) {
        // Youbora: Envio de parametros extras
        if (window.youboraTrackingPlugin) {
          if (
            metadata.group &&
            metadata.group.common &&
            metadata.group.common.extendedcommon
          ) {
            if (
              metadata.group.common.extendedcommon.format &&
              metadata.group.common.extendedcommon.format.name
            ) {
              window.youboraParams[3].value =
                metadata.group.common.extendedcommon.format.name;
            }
          }
        }

        const { media } = metadata;
        if (media) {
          this.duration = media.duration ? media.duration.seconds : null;
          this.src = media.video_url;
        }
        const common = metadata.group ? metadata.group.common : null;
        if (common) {
          // VOD
          this.title = `${common.id}-${common.title}`;
          this.title2 = 'Undefined';

          const extCommon = common.extendedcommon ? common.extendedcommon.media : null;
          if (extCommon) {
            if (extCommon.serie && extCommon.serie.title) {
              // VOD Serie
              this.title = `${extCommon.serie.id}-${extCommon.serie.title}`;
              this.title2 = `${extCommon.serieseason.id}-${extCommon.serieseason.number}-${common.id}-${common.title}`;
            }
            this.isLive = extCommon.islive !== '0';
            if (this.isLive) {
              // LIVE
              const liveMetadata = window.youboraChannelMetadata;
              this.title = `${common.id}-${common.title}`;
              this.title2 = liveMetadata
                ? `${liveMetadata.program_event_id}-${liveMetadata.program_event_name}`
                : null;
            }

            if (extCommon.profile && extCommon.profile.hd) {
              this.rendition = extCommon.profile.hd.detail;
            }
          }
        }
      }

      /**
       * ESTO SOLO APLICA A NPVR, para recuperar título
       */
      if(e.event) {
        if(e.event.title) {
          this.title = e.event.title;
        }
        else {
          this.title = 'npvr';
        }
      }

      this.version = pkg.version;

      const youboraParams = {};
      window.youboraParams.forEach((param, index) => {
        youboraParams[`extraparam.${index + 1}`] = param.value;
      });
      window.youboraTrackingPlugin.setOptions(youboraParams);

      if (!metadata || !metadata.media || !metadata.media.initial_playback_in_seconds) {
        if (this.fireStart && typeof this.fireStart === 'function') {
          this.fireInit();
          this.fireStart();
        }
      }
    } catch (e) {
      // console.log("YouboraEvent Error in Adapter setup");
    }


      // Reset stream anterior
        if (this.currentStreamContentType !== null) {
          this.setCurrentStreamContentType(null);
      }

      // Update stream content type
      if (streamContentType !== null) {
          this.setCurrentStreamContentType(streamContentType);
      }
  },

  bitRateChange(bitrate, bandwidth) {
    // console.log("YouboraEvent bitRateChange bitrate:",bitrate,", bandwidth:",bandwidth);
    this.bitrate = bitrate;
  },

  playing() {
    // console.log("YouboraEvent playing");
    if (this.fireStart && typeof this.fireStart === 'function' && this.src !== null) {
      this.fireInit();
      this.fireStart();
    }
    if (this.currentTime > 0.5) {
      if (this.fireJoin && typeof this.fireJoin === 'function') this.fireJoin();
    }
    if(this.fireSeekEnd && typeof this.fireSeekEnd === 'function') {
      this.fireSeekEnd();
    }
  },

  start() {
    // console.log("YouboraEvent start");
    if (this.fireStart && typeof this.fireStart === 'function') this.fireStart();
  },

  play() {
    // console.log("YouboraEvent play");
    if (this.fireStart && typeof this.fireStart === 'function') this.fireStart();
  },

  pause() {
    // console.log("YouboraEvent pause");
    if (this.firePause && typeof this.firePause === 'function') this.firePause();
    // this.execFunction(this.firePause);
  },

  resume() {
    // console.log("YouboraEvent resume");
    if (this.fireResume && typeof this.fireResume === 'function') this.fireResume();
  },

  stop() {
    // console.log("YouboraEvent stop");
    if (this.fireStop && typeof this.fireStop === 'function') this.fireStop();
    if (this.resetMetadata && typeof this.resetMetadata === 'function') this.resetMetadata();
  },

  episodeChange() {
    // console.log("YouboraEvent episodeChange");
    if (this.fireStop && typeof this.fireStop === 'function') this.fireStop();
    if (this.resetMetadata && typeof this.resetMetadata === 'function') this.resetMetadata();
  },

  leaveContent() {
    // console.log("YouboraEvent leaveContent");
    if (this.fireStop && typeof this.fireStop === 'function') this.fireStop();
    if (this.resetMetadata && typeof this.resetMetadata === 'function') this.resetMetadata();
  },

  leaveApp() {
    // console.log("YouboraEvent leaveApp");
    if (this.fireStop && typeof this.fireStop === 'function') this.fireStop();
    if (this.resetMetadata && typeof this.resetMetadata === 'function') this.resetMetadata();
  },

  foward() {
    // console.log("YouboraEvent foward");
    if (this.fireSeekBegin && typeof this.fireSeekBegin === 'function') this.fireSeekBegin();
  },
  rewind() {
    // console.log("YouboraEvent rewind");
    if (this.fireSeekBegin && typeof this.fireSeekBegin === 'function') this.fireSeekBegin();
  },
  foward30() {
    // console.log("YouboraEvent foward30");
    if (this.fireSeekBegin && typeof this.fireSeekBegin === 'function') this.fireSeekBegin();
  },
  rewind30() {
    // console.log("YouboraEvent bufferEnd");
    if (this.fireSeekBegin && typeof this.fireSeekBegin === 'function') this.fireSeekBegin();
  },
  end() {
    if (this.isAudio()) return;

    // console.log("YouboraEvent rewind30");
    if (this.fireStop && typeof this.fireStop === 'function') this.fireStop();
    if (this.resetMetadata && typeof this.resetMetadata === 'function') this.resetMetadata();
  },

  error(e, time, errorCode, errorMessage) {
    // console.log("YouboraEvent error");
      if (this.fireError && typeof this.fireError === 'function') this.fireError(errorCode, errorMessage);
  },
  errorContent(e, time, errorCode, errorMessage) {
    if (this.isAudio()) return;
    // console.log("YouboraEvent errorContent");
      if (this.fireError && typeof this.fireError === 'function') this.fireError(errorCode, errorMessage);
  },
  errorLive(e, time, errorCode, errorMessage) {
    // console.log("YouboraEvent errorLive");
      if (this.fireError && typeof this.fireError === 'function') this.fireError(errorCode, errorMessage);
  },

  apiError(e, time) {
    // console.log("YouboraEvent apiError");
    // console.error('[APIERROR] YouboraManager > apiError this.getPlayhead(): ', this.getPlayhead());
    if(e && (e.url.includes('level') || e.url.includes('level-user'))) return

    const ct = this.getPlayhead();
    if (!isNaN(ct) && ct !== null) {
      if (this.fireError && typeof this.fireError === 'function') {
        let emsg = e.message;

        // En caso de que venga de un retry playing
        if (e && typeof e.msg !== 'undefined') {
          emsg = e.msg;
          if (e && typeof e.url !== 'undefined' && e.url) {
            emsg = `${emsg} | URL: ${e.url}`;
          }
          if (e && typeof e.retryPlaying !== 'undefined') {
            emsg = 'Retry playing';

            if (
              e.retryPlaying.pgm &&
              e.retryPlaying.pgm.group &&
              e.retryPlaying.pgm.group.common &&
              e.retryPlaying.pgm.group.common.extendedcommon &&
              e.retryPlaying.pgm.group.common.extendedcommon.media &&
              e.retryPlaying.pgm.group.common.extendedcommon.media.proveedor &&
              e.retryPlaying.pgm.group.common.extendedcommon.media.proveedor.nombre
            ) {
              emsg = `${emsg} | ${e.retryPlaying.pgm.group.common.extendedcommon.media.proveedor.nombre}`;
            }

            // if (
            //     e.retryPlaying.pgm &&
            //     e.retryPlaying.pgm.group &&
            //     e.retryPlaying.pgm.group.common &&
            //     e.retryPlaying.pgm.group.common.id
            // ) {
            //     emsg = emsg + ' | ' + e.retryPlaying.pgm.group.common.id;
            // }
          }
        }
        // console.error('[APIERROR] YouboraManager > apiError e: ', e);
        this.fireError(emsg);
      }
    }
  },

  _fireBufferBegin(){
    logger.debug('fireBufferBegin');
    this.fireBufferBegin();
  },

  _fireBufferEnd(){
    logger.debug('fireBufferEnd');
    this.fireBufferEnd();
  },

  resetMetadata() {
    // console.log("YouboraEvent resetMetadata");
    this.duration = null;
    this.src = null;
    this.title = null;
    this.title2 = null;
    this.isLive = null;
    this.rendition = null;
    this.currentTime = null;
    this.bitrate = null;
    if (this.monitor && this.monitor.stop && typeof this.monitor.stop === 'function') {
      this.monitor.stop();
    }

    this.currentStreamContentType = null;
  }
});

module.exports = YouboraTracker;



// WEBPACK FOOTER //
// ./src/utils/trackers/YouboraTracker.js